import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../../app/GetProxy";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../../service/requestHandler";

const proxy = GetProxy();
const cookies = new Cookies();
const Apitoken = cookies.get("apitoken");
const User = cookies.get("username");

export const configurationFilterSelectedListApi = createDynamicThunk(
  "configurationFilterSelectedListApi",
  `/aws/api/v1/architectureCompliance/getConfigurationData/${cookies.get("decodedUsername")}`,
  [],
  "GET"
);
export const configurationFilterSaveApi = createDynamicThunk(
  "configurationFilterSaveApi",
  "/aws/api/v1/architectureCompliance/saveConfiguration"
);

export const initialState = {
  alertMessage: "",
  alertType: "",
  configurationFilterListApiData: [],
  configurationFilterListApiLoading: false,
  configurationFilterSaveApiData: [],
  configurationFilterSaveApiLoading: false,
};

export const configurationFilterSlice = createSlice({
  name: "configurationFilterSlice",
  initialState,
  reducers: {
    resetconfigurationFilterSlice: () => initialState,
    resetConfigurationFilterData: () => initialState,
    setAlertMessage: (state, action) => {
      state.alertMessage = action.payload.message;
      state.alertType = action.payload.type;
    },
    clearAlertMessage: (state) => {
      state.alertMessage = "";
      state.alertType = "";
    },
  },
  extraReducers: (builder) => {
    addApiCases(
      builder,
      configurationFilterSaveApi,
      "configurationFilterSaveApiData"
    );
    addApiCases(
      builder,
      configurationFilterSelectedListApi,
      "configurationFilterSelectedListApiData"
    );
  },
});

export const {
  resetconfigurationFilterSlice,
  resetConfigurationFilterData,
  setAlertMessage,
  clearAlertMessage,
} = configurationFilterSlice.actions;
export default configurationFilterSlice.reducer;
